const distributorInfo = {
  collaboration_text: 'string',
  distributor_id: 'string',
  title: 'string',
  distributor_logo: {
    title: 'string',
    url: 'string',
  },
};

export const layoutData = {
  globalSettings: {
    favicon: null,
  },
  footerData: {
    hideFooterLinks: true,
    copyright: 'Raisin SE, Berlin',
    credits: [],
    disclaimer: '',
    display_footer_links: false,
    displayUsContactBanner: false,
    display_trustpilot: false,
    footer_links: [],
    legal_links: [
      {
        title: 'Site Information',
        href: '/site-information/',
      },
    ],
    hideSocialMediaHeading: false,
    usContactBanner: {
      phone: {
        phone_number: '8449943276',
        phone_link_text: '(844) 994-EARN (3276)',
      },
      email: {
        email_address: 'info.us@raisin.com',
      },
    },

    mobile_banner: {
      display_mobile_banner: false,
      icon: [
        {
          uid: 'bltd9daaf29282d1f4b',
          _content_type_uid: 'icons_set',
        },
      ],
    },
    contactInformationData: null,
    mobileBannerIconURL: null,
    socialMediaIcons: null,
    trustpilotData: null,
    hideCountryPicker: true,
  },
  headerData: {
    globalSettings: null,
    mainNavRetail: null,
    mainNavRetailAuth: null,
    distributorLogoData: [distributorInfo],
    distributorInfo,
    giftIconUrl: null,
    copyIconUrl: null,
  },
  localizedMessages: {},
  locale: 'en',
};
